module.exports = __webpack_public_path__ + "img/金豐30.bbcd84e1.svg";